import { memo } from "react";
import Error from "./Error";
import IntlMessages from "components/Message/IntlMessages";

const NoSecuritiesFoundError = ({ state, ...props }) => {
  const documentPathUrl = "/static/moneyconnect/secondary-market/settlement-doc/prospectus/Prospectus.pdf";

  const _state = {
    ...(state || {}),
    extraMessages: [
      <div
        className="link"
        tabIndex="0"
        role="link"
        onClick={() => {
          window.open(documentPathUrl, "_blank");
        }}
      >
        <IntlMessages id="global.securities-depository-manual" />
      </div>,
    ],
  };
  return <Error state={_state} {...props} />;
};

export default memo(NoSecuritiesFoundError);
